import { render, staticRenderFns } from "./UtilityStorageCarousel.vue?vue&type=template&id=968dd93e&scoped=true&"
import script from "./UtilityStorageCarousel.vue?vue&type=script&lang=js&"
export * from "./UtilityStorageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968dd93e",
  null
  
)

export default component.exports